// @flow
// eslint-disable-next-line no-use-before-define
import React, { useContext, useEffect } from 'react';
import { BreakpointContext, XLARGE } from '@core-ui/breakpoint-provider';
import { Deferred } from '@core-ui/reporting';
import { StitchInverseStyleProvider } from '@core-ui/react-stitch';
// $FlowFixMe
import { BopisProvider } from '@core-ui/bopis';
import { withPersonalizationData } from '@core-ui/personalization-provider';
import { PersonalizationContextData } from '@core-ui/personalization-provider/types';
// $FlowFixMe
import { categoryPageEngagementDatalayer } from '../../datalayer/events/category-page-engagement';
import { RelatedCategoriesProvider } from '../related-categories/context';
// $FlowFixMe
import { getCurrentCategory } from '../../adapters/categoriesHandler';
// $FlowFixMe
import { getRelatedCategories } from '../../adapters/categoriesHandler';
import CategoryBanner, { shouldHideTitleText } from '../category-banner';
import RelatedCategories from '../related-categories';
import { modelToggleEnabled } from '@cat/size-model-toggle';
// $FlowFixMe
import CategoryBannerContainer from './styled/CategoryBannerContainer';
// $FlowFixMe
import useMixedGrid from '../../hooks/features/useMixedGrid/useMixedGrid';
// $FlowFixMe
import useBottomProductBreadcrumbs from '../../hooks/features/useBottomProductBreadcrumbs';
import CategoryBreadcrumbs from '../category-breadcrumbs';
// $FlowFixMe
import useBRRedesign from '../../hooks/features/useBRRedesign';
import LeftFacetedGrid from '../left-faceted-grid';
// $FlowFixMe
import GridDivision from './styled/GridDivision';
// $FlowFixMe
import MainWrapper from './styled/MainWrapper';
import {
  TranslationData,
  CriticalResources,
  Locale,
  SelectedNodes,
  LeftNavType,
  DataLayer,
  ContentData,
} from './types';
import {
  Breadbrumbs,
  HighPriorityEvent,
  LocationConfig,
  WebItem,
} from 'src/app/App';

const doesPageIncludeTopPrimaryBanner = (marketingData: ContentData) => {
  return marketingData?.data?.components?.topPrimary;
};

const doesPageIncludeTopBanner = (marketingData: ContentData) => {
  return marketingData?.data?.components?.top;
};

const getIsCategoryHeaderVisible = (
  categoryContentData: ContentData,
  isBRRedesignEnabled: boolean
) => {
  return !doesPageIncludeTopBanner(categoryContentData) && isBRRedesignEnabled;
};

type Props = {
  abbrBrand: string;
  abbrNameForTealium: string;
  brand: string;
  criticalResources: CriticalResources;
  enabledFeatures: { [key: string]: boolean };
  featureVariables: { [key: string]: string };
  errorLogger: () => void;
  initialSizeClass: string;
  locale: Locale;
  pageType: string;
  marketAgnosticBrandCode: number;
  translations: TranslationData; // #flow-typed
  highPriorityEvents: Array<HighPriorityEvent>; // TODO
  params: { cid: string; style: string; color: string }; // TODO style not required?
  breadcrumbs: Breadbrumbs; // TODO
  contentData: ContentData; // TODO
  webHierarchy: WebItem[]; // TODO
  selectedNodes: SelectedNodes;
  abSeg: { [key: string]: string }; // TODO
  market: string; // TODO
  categoryName: string;
  subcategoryName: string;
  leftNav: LeftNavType;
  datalayer: DataLayer; // TODO
  criticalCss: []; // TODO
  brandName: string; // TODO
  businessUnitId: number; // TODO
  locationConfig: LocationConfig; // TODO
  productsUrl: string;
  productsApiKey: string;
  personalizationData: PersonalizationContextData;
  showPreviewBar: boolean; // TODO
  smartCrosslinks: {
    crosslinks: Array<{ [key: string]: string }>;
    globalVariables: { [key: string]: string };
  };
};

const BreadCrumbWrapper = ({
  isBottom,
  showCategorybreadcrumbs,
  breadcrumbs,
}: {
  isBottom: boolean;
  showCategorybreadcrumbs: boolean;
  breadcrumbs: Breadbrumbs;
}) => {
  const isBRRedesignEnabled = useBRRedesign();

  return (
    <CategoryBreadcrumbs
      showCategorybreadcrumbs={
        isBRRedesignEnabled ? isBottom : showCategorybreadcrumbs
      }
      breadcrumbs={breadcrumbs}
    />
  );
};

const CategoryPage = (props: Props) => {
  const {
    abbrBrand,
    abSeg,
    breadcrumbs,
    categoryName,
    subcategoryName,
    contentData,
    criticalCss,
    datalayer,
    enabledFeatures,
    errorLogger,
    featureVariables,
    highPriorityEvents,
    market,
    locationConfig,
    params: { cid, color },
    pageType,
    productsUrl,
    productsApiKey,
    selectedNodes,
    webHierarchy,
    smartCrosslinks,
  } = props;

  const { greaterOrEqualTo, smallerThan } = useContext(BreakpointContext);

  const bottomProductBreadcrumbsEnabled = useBottomProductBreadcrumbs();
  const isMixedGridEnabled = useMixedGrid();
  const isBRRedesignEnabled = useBRRedesign();

  const isDesktop = greaterOrEqualTo(XLARGE);
  const isMobile = smallerThan(XLARGE);

  useEffect(() => {
    categoryPageEngagementDatalayer(props);
  }, [props]);

  useEffect(() => {
    highPriorityEvents.push({
      name: 'cat1ImageLoaded',
      deferred: new Deferred(),
    });
  }, [highPriorityEvents]);

  const divisionMarketingData = contentData?.division;
  const CATEGORY_BANNERS = 'category-banners';
  const currentCategory = getCurrentCategory({ webHierarchy, selectedNodes });
  const relatedCategoryLinks = getRelatedCategories({
    webHierarchy,
    selectedNodes,
  });

  const isModelToggleEnabled = modelToggleEnabled({
    featureVariables,
    enabledFeatures,
    abSeg,
    market,
    abbrBrand,
    cid,
  });

  const categoryContentData = contentData?.category?.[cid];
  const isCategoryHeaderVisible = getIsCategoryHeaderVisible(
    categoryContentData,
    isBRRedesignEnabled
  );

  return (
    <MainWrapper useBRRedesign={isBRRedesignEnabled}>
      <main>
        {doesPageIncludeTopPrimaryBanner(categoryContentData) && (
          <CategoryBannerContainer>
            <CategoryBanner
              abbrBrand={abbrBrand}
              categoryName={categoryName}
              colorName={color}
              subcategoryName={subcategoryName}
              criticalCss={criticalCss}
              divisionMarketingData={divisionMarketingData}
              hasHiddenTitle={shouldHideTitleText(isMobile, breadcrumbs)}
              mktingType={CATEGORY_BANNERS}
              position="topPrimary"
              selectedNodes={selectedNodes}
            />
          </CategoryBannerContainer>
        )}
        <CategoryBannerContainer
          id="main-content"
          isBRRedesignEnabled={isBRRedesignEnabled}
        >
          <CategoryBanner
            abbrBrand={abbrBrand}
            categoryName={categoryName}
            subcategoryName={subcategoryName}
            colorName={color}
            criticalCss={criticalCss}
            divisionMarketingData={divisionMarketingData}
            hasHiddenTitle={
              isCategoryHeaderVisible == false &&
              shouldHideTitleText(isMobile, breadcrumbs)
            }
            mktingType={CATEGORY_BANNERS}
            position="top"
            selectedNodes={selectedNodes}
          />
        </CategoryBannerContainer>
        <BreadCrumbWrapper
          isBottom={false}
          showCategorybreadcrumbs={!bottomProductBreadcrumbsEnabled}
          breadcrumbs={breadcrumbs}
        />
        <RelatedCategoriesProvider
          cid={cid}
          smartCrosslinks={smartCrosslinks}
          relatedCategoryLinks={relatedCategoryLinks}
        >
          <GridDivision
            useBRRedesign={isBRRedesignEnabled}
            className={`product-grid product-grid--with-left-hand-facets`}
          >
            <BopisProvider
              abSeg={abSeg}
              brand={abbrBrand}
              datalayer={datalayer}
              errorLogger={errorLogger}
              locationAttributeServiceConfig={locationConfig.lasAttributes}
              market={market}
              pageType={pageType}
              personalizationData={props.personalizationData}
            >
              <LeftFacetedGrid
                {...props}
                productsUrl={productsUrl}
                productsApiKey={productsApiKey}
                currentCategory={currentCategory}
                isDesktop={isDesktop}
                isModelToggleEnabled={isModelToggleEnabled}
                isMixedGridEnabled={isMixedGridEnabled}
                webHierarchy={webHierarchy}
                selectedNodes={selectedNodes}
              />
            </BopisProvider>
          </GridDivision>
          <StitchInverseStyleProvider invert={isBRRedesignEnabled}>
            <RelatedCategories isBRRedesignEnabled={isBRRedesignEnabled} />
          </StitchInverseStyleProvider>
        </RelatedCategoriesProvider>
        <BreadCrumbWrapper
          isBottom={true}
          showCategorybreadcrumbs={bottomProductBreadcrumbsEnabled}
          breadcrumbs={breadcrumbs}
        />
        <CategoryBannerContainer>
          <CategoryBanner
            abbrBrand={abbrBrand}
            categoryName={categoryName}
            subcategoryName={subcategoryName}
            criticalCss={criticalCss}
            divisionMarketingData={divisionMarketingData}
            mktingType={CATEGORY_BANNERS}
            position="bottom"
            selectedNodes={selectedNodes}
          />
        </CategoryBannerContainer>
        <div className="cat-modal" />
      </main>
    </MainWrapper>
  );
};

CategoryPage.defaultProps = {
  highPriorityEvents: [],
};

export default withPersonalizationData(CategoryPage);
